import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const userRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    name: ROUTES.USERS,
    component: () => import('@/modules/users/views/UsersIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.USERS_VIEW }
  },
  {
    path: '/users/:id',
    name: ROUTES.USER_DETAILS,
    component: () => import('@/modules/users/views/UserDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.USER_DETAILS_VIEW, checkByUser: true }
  },
  {
    path: '/users/:userId/security',
    name: ROUTES.USER_SECURITY,
    component: () => import('@/modules/users/views/SecurityIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.USER_SECURITY_VIEW }
  },
  {
    path: '/security',
    name: ROUTES.SECURITY,
    component: () => import('@/modules/users/views/SecurityIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.SECURITY_VIEW }
  }
]
